<!-- <ion-app class="app-layout">
  <app-header *ngIf="showHeader"></app-header>
  <app-message-box></app-message-box>
  <section>
    <app-sidebar *ngIf="showSidebar"></app-sidebar>
    <router-outlet></router-outlet>
  </section>
  <app-footer *ngIf="showFooter"></app-footer>
</ion-app>
 -->

 <ion-app class="app">
  <!-- <ion-split-pane when="(min-width: 1300px)" contentId="main"> -->
  <ion-split-pane when="(min-width: 0px)" contentId="main" [ngClass]="{'full-size-alarms' : (alarmsFullSize$ | async) === true}">
    <ion-menu contentId="main" [disabled]="!showSidebar" class="ion-menu">
      <app-sidebar *ngIf="showSidebar" class="sidebar" ></app-sidebar>
    </ion-menu>
    <div id="main" class="width-full">
      <ion-header *ngIf="showHeader">
        <app-header></app-header>
      </ion-header>
      <app-message-box></app-message-box>
      <!-- <ion-content [ngClass]="{'content-footer': showFooter}">
        <router-outlet></router-outlet>
      </ion-content> -->
      <ion-content [ngClass]="{'content-footer': showFooter, 'position-initial': isFacilityDetails()}">
        <router-outlet></router-outlet>
      </ion-content>
      <!-- <ion-footer>
        <app-footer *ngIf="showFooter"></app-footer>
      </ion-footer> -->
    </div>
  </ion-split-pane>
  </ion-app>
